/* ============================================================
   PDP — page-specific scripts
   Loaded conditionally from layout/theme.liquid when template.name == 'product'.
   Modules: gallery thumb-swap · quantity stepper · tabs · scroll reveal.
   Add-to-cart is handled by native form POST to /cart/add (no JS needed).
   For optimistic UI / AJAX add-to-cart, see Fase 3.5 (Cart AJAX API).
   ============================================================ */
(function () {
  /* ============================================================
     GALLERY — thumbnail click changes main image
     ============================================================ */
  const thumbs = document.querySelectorAll('.pdp-thumb');
  const mainImg = document.getElementById('mainImg');
  const mainWrap = document.getElementById('pdpMainImg');

  if (thumbs.length && mainImg && mainWrap) {
    thumbs.forEach(t => {
      t.addEventListener('click', () => {
        if (t.classList.contains('is-active')) return;
        thumbs.forEach(o => {
          o.classList.remove('is-active');
          o.setAttribute('aria-selected', 'false');
        });
        t.classList.add('is-active');
        t.setAttribute('aria-selected', 'true');

        mainWrap.classList.add('is-fading');
        setTimeout(() => {
          mainImg.src = t.dataset.img;
          mainImg.alt = t.dataset.alt || '';
          mainWrap.classList.remove('is-fading');
        }, 200);
      });
    });
  }

  /* ============================================================
     VARIANT SELECTOR — chips para cada option (Color, Talla, etc).
     Al seleccionar:
       1. Encuentra el variant que matchea la combinación de opciones activas.
       2. Actualiza el hidden input #variantId con el id del variant.
       3. Swap la imagen principal a variant.image si existe.
       4. Si el variant está sold out → disabled el botón + label "Sold Out".
     Coexiste con el thumb-swap del gallery: el variant-swap tiene prioridad.
     ============================================================ */
  const variantsDataEl = document.getElementById('productVariantsData');
  const optionGroups = document.querySelectorAll('.pdp-option-group');

  if (variantsDataEl && optionGroups.length) {
    let variants = [];
    try { variants = JSON.parse(variantsDataEl.textContent); }
    catch (err) { console.error('[variants] parse error', err); }

    const variantIdInput = document.getElementById('variantId');
    const ctaBtn = document.getElementById('addToCartBtn');
    const ctaLabel = document.getElementById('addToCartLabel');
    const stockBadge = document.querySelector('.pdp-stock-badge');

    function getActiveOptions() {
      const selected = [];
      optionGroups.forEach(group => {
        const activeChip = group.querySelector('.pdp-option-chip.is-on');
        selected.push(activeChip ? activeChip.dataset.optionValue : null);
      });
      return selected;
    }

    function findVariant(activeOptions) {
      return variants.find(v => {
        if (!v.options || v.options.length !== activeOptions.length) return false;
        return v.options.every((opt, i) => opt === activeOptions[i]);
      });
    }

    function updateChipsAvailability() {
      // Por cada chip, calcular si la combinación resultante sería disponible.
      const activeOptions = getActiveOptions();
      optionGroups.forEach((group, groupIdx) => {
        group.querySelectorAll('.pdp-option-chip').forEach(chip => {
          const testOptions = activeOptions.slice();
          testOptions[groupIdx] = chip.dataset.optionValue;
          const variant = findVariant(testOptions);
          chip.classList.toggle('is-unavailable', !variant || !variant.available);
        });
      });
    }

    function applyVariant() {
      const activeOptions = getActiveOptions();
      const variant = findVariant(activeOptions);
      if (!variant) return;

      // Update hidden input.
      if (variantIdInput) variantIdInput.value = variant.id;

      // Update displayed "current value" label en cada option-head.
      optionGroups.forEach((group, idx) => {
        const valueLabel = group.querySelector('[data-current-value]');
        if (valueLabel) valueLabel.textContent = activeOptions[idx] || '';
      });

      // Swap main image si la variante tiene featured_image.
      if (variant.image && mainImg && mainWrap) {
        mainWrap.classList.add('is-fading');
        setTimeout(() => {
          mainImg.src = variant.image;
          mainImg.alt = variant.alt || mainImg.alt;
          mainWrap.classList.remove('is-fading');
        }, 200);
        // Sincronizar thumb activo si la imagen está entre los thumbs.
        document.querySelectorAll('.pdp-thumb').forEach(t => {
          const isMatch = t.dataset.img === variant.image;
          t.classList.toggle('is-active', isMatch);
          t.setAttribute('aria-selected', isMatch ? 'true' : 'false');
        });
      }

      // Update CTA state según availability.
      if (ctaBtn && ctaLabel) {
        if (variant.available) {
          ctaBtn.disabled = false;
          ctaLabel.textContent = 'Agregar al carrito';
        } else {
          ctaBtn.disabled = true;
          ctaLabel.textContent = 'Sold Out';
        }
      }

      // Update stock badge en la imagen.
      if (stockBadge) {
        if (variant.available) {
          stockBadge.textContent = 'In Stock';
          stockBadge.classList.remove('pdp-stock-badge--bo');
        } else {
          stockBadge.textContent = 'Out of Stock';
          stockBadge.classList.add('pdp-stock-badge--bo');
        }
      }

      updateChipsAvailability();
    }

    optionGroups.forEach(group => {
      group.querySelectorAll('.pdp-option-chip').forEach(chip => {
        chip.addEventListener('click', () => {
          group.querySelectorAll('.pdp-option-chip').forEach(c => c.classList.remove('is-on'));
          chip.classList.add('is-on');
          applyVariant();
        });
      });
    });

    // Inicializar disponibilidad de chips al cargar.
    updateChipsAvailability();
  }

  /* ============================================================
     QUANTITY STEPPER
     ============================================================ */
  const qtyMinus = document.getElementById('qtyMinus');
  const qtyPlus  = document.getElementById('qtyPlus');
  const qtyInput = document.getElementById('qtyInput');

  if (qtyMinus && qtyPlus && qtyInput) {
    function syncQty(v) {
      v = Math.max(1, Math.min(10, (v | 0) || 1));
      qtyInput.value = v;
      qtyMinus.disabled = v <= 1;
      qtyPlus.disabled  = v >= 10;
    }
    qtyMinus.addEventListener('click', () => syncQty(parseInt(qtyInput.value, 10) - 1));
    qtyPlus.addEventListener('click',  () => syncQty(parseInt(qtyInput.value, 10) + 1));
    qtyInput.addEventListener('change', e => syncQty(parseInt(e.target.value, 10)));
    syncQty(parseInt(qtyInput.value, 10) || 1);
  }

  /* ============================================================
     TABS
     ============================================================ */
  const tabBtns = document.querySelectorAll('.pdp-tab-btn');
  const panels  = document.querySelectorAll('.pdp-tab-panel');
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      tabBtns.forEach(b => {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
      });
      panels.forEach(p => {
        p.classList.toggle('is-active', p.dataset.panel === target);
      });
    });
  });

  /* ============================================================
     ADD TO CART — AJAX (Cart AJAX API)
     Intercepta el form submit, hace POST a /cart/add.js sin reload,
     actualiza el badge del header y muestra flash "Agregado · N" verde.
     Si JS falla o el browser no tiene fetch, el form sigue funcionando
     como POST nativo (fallback al redirect a /cart).
     ============================================================ */
  const cartForm = document.getElementById('addToCartForm');
  const cartBtn  = document.getElementById('addToCartBtn');
  const cartLabel = document.getElementById('addToCartLabel');

  if (cartForm && cartBtn && cartLabel && window.fetch) {
    const originalLabel = cartLabel.textContent;

    cartForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (cartBtn.disabled) return;

      const formData = new FormData(cartForm);
      const qty = parseInt(formData.get('quantity'), 10) || 1;

      cartBtn.disabled = true;
      cartLabel.textContent = 'Agregando…';

      try {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        });

        if (!addRes.ok) {
          const err = await addRes.json().catch(() => ({}));
          throw new Error(err.description || err.message || 'No se pudo agregar al carrito');
        }

        // Get fresh cart state for accurate count
        const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        const cart = await cartRes.json();

        // Update header badge through site.js helper
        if (window.SpecWorks && typeof window.SpecWorks.setCartCount === 'function') {
          window.SpecWorks.setCartCount(cart.item_count);
        }

        // Visual feedback
        cartBtn.classList.add('is-added');
        cartLabel.textContent = `Agregado · ${qty}`;

        setTimeout(() => {
          cartBtn.classList.remove('is-added');
          cartLabel.textContent = originalLabel;
          cartBtn.disabled = false;
        }, 1800);
      } catch (err) {
        console.error('[add-to-cart]', err);
        cartBtn.classList.add('is-error');
        cartLabel.textContent = 'Error · intenta de nuevo';
        setTimeout(() => {
          cartBtn.classList.remove('is-error');
          cartLabel.textContent = originalLabel;
          cartBtn.disabled = false;
        }, 2200);
      }
    });
  }

  /* ============================================================
     SCROLL REVEAL
     ============================================================ */
  const revealTargets = document.querySelectorAll('.reveal');
  if (revealTargets.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(en => {
        if (en.isIntersecting) {
          en.target.classList.add('is-visible');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.15 });
    revealTargets.forEach(el => io.observe(el));
  }
})();
